import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
    container: {
        backgroundColor: '#fff',
        height: 60,
        width: '100%',
        position: 'absolute',
        top: 0,
        zIndex: 999
    },
    content: {
        width: 'auto',
        height: 60,
        paddingLeft: 15,
        paddingRight: 15,
        flexDirection: 'row',
        alignContent: 'center',
        justifyContent: 'center',
    },
    label: {
        marginTop: -2,
        color: '#222',
        fontSize: 14,
    },
    labelActive: {
        marginTop: -2,
        color: '#999',
        fontSize: 14
    },
    tab: {
        textTransform: 'uppercase',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        paddingLeft: 10,
        paddingRight: 10,

    }
});

export default styles;
